"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { useLocalizedRouter as useRouter } from "@/lib/i18n/client";
import { useFiltersStore } from "@/lib/filters-store";

// Aislado en su propio componente (en vez de vivir dentro de EventosClient)
// porque useSearchParams() obliga a envolver en Suspense, y cualquier
// componente dentro de esa frontera queda excluido del renderizado
// estático/servidor — de haber quedado junto al grid de eventos, TODO
// /eventos habría vuelto a bailoutear a client-side-only, anulando el fetch
// inicial del servidor (ver app/eventos/page.tsx). No renderiza nada visual,
// solo hidrata filtros desde la URL (?category=, etc.) hacia el store
// compartido y avisa que terminó.
export function UrlFiltersBootstrap() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const { setSearch, setCategory, setWhen, setPrice, setDistricts, setBootstrapDone } = useFiltersStore();

  useEffect(() => {
    const fromSearch = searchParams.get("search");
    const fromCategory = searchParams.get("category");
    const fromWhen = searchParams.get("when");
    const fromPrice = searchParams.get("price");
    const fromDistricts = searchParams.get("districts");
    if (fromSearch || fromCategory || fromWhen || fromPrice || fromDistricts) {
      if (fromSearch) setSearch(fromSearch);
      if (fromCategory) setCategory(fromCategory);
      if (fromWhen === "today" || fromWhen === "weekend" || fromWhen === "all") setWhen(fromWhen);
      if (fromPrice === "free" || fromPrice === "paid" || fromPrice === "unknown" || fromPrice === "all") setPrice(fromPrice);
      if (fromDistricts) setDistricts(fromDistricts.split(","));
      router.replace("/eventos", { scroll: false });
    }
    setBootstrapDone(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
